define('LNRS/Components/Content/CustomHighlight',["jquery"], function ($) {

    function CustomHighlight(scope, isInEditing, ctaLinkSelector,
        imageSmallWidth,
        imageMediumWidth,
        imageBigWidth,
        imageUrlSmall,
        imageUrlMedium,
        imageUrlBig,
        fullSizeImage,
        primaryImageGuid,
        secondImageUrlSmall,
        secondImageUrlMedium,
        secondImageUrlBig,
        secondFullSizeImage,
        secondaryImageGuid) {

        if (!isInEditing) {
            var highlightSize = $('#' + primaryImageGuid).width();

            if (highlightSize > imageBigWidth) {
                $('#' + primaryImageGuid).attr("src", fullSizeImage);
                $('#' + secondaryImageGuid).attr("src", secondFullSizeImage);
            }
            else if (highlightSize > imageMediumWidth) {
                $('#' + primaryImageGuid).attr("src", imageUrlBig);
                $('#' + secondaryImageGuid).attr("src", secondImageUrlBig);
            }
            else if (highlightSize > imageSmallWidth) {
                $('#' + primaryImageGuid).attr("src", imageUrlMedium);
                $('#' + secondaryImageGuid).attr("src", secondImageUrlMedium);
            }
            else {
                $('#' + primaryImageGuid).attr("src", imageUrlSmall);
                $('#' + secondaryImageGuid).attr("src", secondImageUrlSmall);
            }

            /*if (imageUrl.length > 0 || secondaryImageUrl.length > 0) {
                var primaryImage = $('.' + primaryImageGuid);
                var secondaryImage = $('.' + secondaryImageGuid);

                var tabSet = primaryImage.closest('.tab-set-mobile-drop-down');

                if (tabSet && $(tabSet).offset()) {
                    if (isVisible(tabSet)) {
                        loadImages(primaryImage, secondaryImage, imageUrl, secondaryImageUrl);
                    } else {
                        setScrollEvent(tabSet, primaryImage, secondaryImage, imageUrl, secondaryImageUrl);
                    }
                } else {
                    if (isVisible(primaryImage) || isVisible(secondaryImage)) {
                        loadImages(primaryImage, secondaryImage, imageUrl, secondaryImageUrl);
                    } else {
                        setScrollEvent(null, primaryImage, secondaryImage, imageUrl, secondaryImageUrl);
                    }
                }
            }*/
        }

        $(scope).on("click", function (e) {
            // Removing because of LNRSSUP-133, uncomment if it's breaking Custom Highlight somewhere else
            //e.preventDefault();
            var $cta  = $(this).find(ctaLinkSelector);
            if ($cta.length) $cta.triggerHandler("click");
        });
    }

    function setScrollEvent(tabSet, primaryImage, secondaryImage, imageUrl, secondaryImageUrl) {
        var scrollHandler = function () {
            if (tabSet && $(tabSet).offset()) {
                if (isVisible(tabSet)) {
                    loadImages(primaryImage, secondaryImage, imageUrl, secondaryImageUrl);
                    $(window).off("scroll", scrollHandler);
                }
            } else {
                if (isVisible(primaryImage) || isVisible(secondaryImage)) {
                    loadImages(primaryImage, secondaryImage, imageUrl, secondaryImageUrl);
                    $(window).off("scroll", scrollHandler);
                }
            }
        }

        $(window).on("scroll", scrollHandler);
    }

    function loadImages(primaryImage, secondaryImage, imageUrl, secondaryImageUrl) {
        if (imageUrl.length > 0) {
            primaryImage.attr('src', imageUrl);
        }

        if (secondaryImageUrl.length > 0) {
            secondaryImage.attr('src', secondaryImageUrl);
        }
    }

    function isVisible(element) {
        if (element && $(element).offset()) {
            var elementTop = $(element).offset().top;
            var viewportTop = $(window).scrollTop();
            var viewportBottom = viewportTop + $(window).height();

            if (viewportBottom > elementTop) {
                return true;
            }
        }
        return false;
    }

    return function initCustomHighlight(args) {
        return new CustomHighlight(
            args.scope,
            args.IsInEditing,
            args.CtaLinkSelector,
            args.ImageSmallWidth,
            args.ImageMediumWidth,
            args.ImageBigWidth,
            args.ImageUrlSmall,
            args.ImageUrlMedium,
            args.ImageUrlBig,
            args.FullSizeImage,
            args.PrimaryImageGuid,
            args.SecondImageUrlSmall,
            args.SecondImageUrlMedium,
            args.SecondImageUrlBig,
            args.SecondFullSizeImage,
            args.SecondaryImageGuid);
    };
});
